import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Add /api prefix to backend URL for all API calls
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export const api = {
  // Health & Status
  health: () => axios.get(`${API}/health`),
  ready: () => axios.get(`${API}/ready`),

  // Chat
  chat: (message, sessionId, enableThinking = false, forceTier = null) =>
    axios.post(`${API}/chat`, {
      message,
      session_id: sessionId,
      enable_thinking: enableThinking,
      force_tier: forceTier,
    }),
  
  getChatHistory: (sessionId) => axios.get(`${API}/chat/history/${sessionId}`),
  clearChatHistory: (sessionId) => axios.delete(`${API}/chat/history/${sessionId}`),

  // Analytics
  getMetrics: () => axios.get(`${API}/analytics/metrics`),
  getTierAnalytics: (hours = 24) => axios.get(`${API}/analytics/tiers`, { params: { hours } }),
  getLatencyDistribution: (hours = 24) => axios.get(`${API}/analytics/latency`, { params: { hours } }),
  getCostAnalysis: (days = 7) => axios.get(`${API}/analytics/costs`, { params: { days } }),
  getRecentActivity: (limit = 10) => axios.get(`${API}/analytics/activity`, { params: { limit } }),

  // Audit Logs
  getAuditLogs: (limit = 50, offset = 0, tier = null) =>
    axios.get(`${API}/audit/logs`, { params: { limit, offset, tier } }),

  // Settings
  getSettings: () => axios.get(`${API}/settings`),
  updateSettings: (settings) => axios.patch(`${API}/settings`, settings),

  // Tiers
  getTiers: () => axios.get(`${API}/tiers`),

  // Channels
  getChannelsStatus: () => axios.get(`${API}/channels/status`),
  getWhatsAppQR: () => axios.get(`${API}/channels/whatsapp/qr`),
  getWhatsAppStatus: () => axios.get(`${API}/channels/whatsapp/status`),
  setupTelegramWebhook: () => axios.post(`${API}/channels/telegram/setup`),

  // Intent Training & Feedback
  getIntents: () => axios.get(`${API}/intents`),
  getFeedbackStats: () => axios.get(`${API}/intents/stats`),
  getPendingFeedback: (limit = 50) => axios.get(`${API}/intents/pending`, { params: { limit } }),
  submitFeedback: (feedback) => axios.post(`${API}/intents/feedback`, feedback),
  approveFeedback: (feedbackId) => axios.post(`${API}/intents/feedback/${feedbackId}/approve`),
  rejectFeedback: (feedbackId) => axios.post(`${API}/intents/feedback/${feedbackId}/reject`),
  addIntentExample: (example) => axios.post(`${API}/intents/examples`, example),
  testClassification: (query) => axios.post(`${API}/intents/test`, { query }),

  // Metrics & Cache
  getMetricsJson: () => axios.get(`${API}/metrics/json`),
  getCacheStats: () => axios.get(`${API}/metrics/cache`),
  clearCache: () => axios.delete(`${API}/metrics/cache`),
  getRateLimitStats: () => axios.get(`${API}/metrics/rate-limits`),
};

export default api;
